import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {SpeedInsights} from "@vercel/speed-insights/react";

//design3
import HomePage from "./pages/design3/home"; // Import your home page for design3

import Aboutorrbiit from "./pages/design3/aboutusorrbiit";
import Termsorrbiit from "./pages/design3/termsorrbiit";
import PrivacyPolicy from "./pages/design3/privacypolicyorrbiit";



import Orrbiithome from "./pages/design3/orrbiithome"; // Import your category34 page for design3
import Facialdetail3 from "./pages/design3/facialdetail3"; // Import your facial detail page for design3
import BoutiqueAbout from "./pages/design3/boutiqueabout"; // Import your about page for design3
import Support from "./pages/design3/support"; // Import your support page
import BeautyCategory from "./pages/design3/beautycategory";

import Facialservices from "./pages/design3/facialservices"; // Import your thank you page
import Casmarafacial from "./pages/design3/casmarafacial"; // Import your casmara facial page
import O3facial from "./pages/design3/o3facial"; // Import your o3 facial page
import Repechagefacial from "./pages/design3/repechagefacial"; // Import your repichage facial page
import Zenithfacial from "./pages/design3/zenithfacial"; // Import your zenith facial page
import ThalgoFacial from "./pages/design3/thalgofacial"; // Import your thalgo facial page
import Koreanfacial from "./pages/design3/koreanfacial"; // Import your korean facial page

import Waxing from "./pages/design3/waxing";
import Bellywax from "./pages/design3/bellywax";
import Bikiniwax from "./pages/design3/bikiniwax";
import Combowax from "./pages/design3/combowax";
import Facewax from "./pages/design3/facewax";
import Handwax from "./pages/design3/handwax";
import Legwax from "./pages/design3/legwax";
import Fullbodywax from "./pages/design3/fullbodywax";
import Underarmwax from "./pages/design3/underarmwax";
import Threadingservices from "./pages/design3/threadingservices";

import CleanupServices from "./pages/design3/cleanupservices";
import Detanbleach from "./pages/design3/detanbelach";
import Combodetanbleach from "./pages/design3/combodetanbleach";
import Bleach from "./pages/design3/bleach";
import Detan from "./pages/design3/detan";

import Manipediservices from "./pages/design3/manipediservices"; // Import your manipediservices page for design3
//travel
import TravelHomePage from "./pages/design3/travelhome"; // Import your travel home page
//NGO

import NGOHome from "./pages/ngo/ngohome2"; // Import your NGO home page 2
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Orrbiithome />} />
       <Route path="/aboutus" element={<Aboutorrbiit/>}/>
       <Route path="/termsandconditions" element={<Termsorrbiit/>}/>
       <Route path="/privacypolicy" element={<PrivacyPolicy/>}/>
        
        
        <Route path="/orrbiitelegance" element={<HomePage />} /> 
       {/* <Route path="/boutiqueproducts3" element={<Productpage3 />} /> {/* New route for design3 product page */}
        
        <Route path="/orrbiithome" element={<Orrbiithome />} /> {/* New route for orrbiit home page */}
       
        <Route path="/facialdetail3" element={<Facialdetail3 />} /> {/* New route for design3 facial detail page */}
        <Route path="/orrbiitabout" element={<BoutiqueAbout />} /> {/* New route for about page in design3 */}
        <Route path="/support" element={<Support />} /> {/* New route for support page */}
        <Route path="/category" element={<BeautyCategory />} /> {/* New route for beauty category page */}

        
        <Route path="category/facialservices" element={<Facialservices />} /> {/* New route for facialservices page */}
        <Route path="category/facialservices/casmara" element={<Casmarafacial />} />
        <Route path="category/facialservices/o3" element={<O3facial />} />
        <Route path="category/facialservices/repechage" element={<Repechagefacial />} />
        <Route path="category/facialservices/zenith" element={<Zenithfacial />} />
        <Route path="category/facialservices/thalgo" element={<ThalgoFacial />} />
        <Route path="category/facialservices/korean" element={<Koreanfacial />} />

        <Route path="category/waxing" element={<Waxing />} />
        <Route path="category/waxing/belly" element={<Bellywax />} />
        <Route path="category/waxing/bikini" element={<Bikiniwax />} />
        <Route path="category/waxing/combo" element={<Combowax />} />
        <Route path="category/waxing/face" element={<Facewax />} />
        <Route path="category/waxing/hand" element={<Handwax />} />
        <Route path="category/waxing/leg" element={<Legwax />} />
        <Route path="category/waxing/fullbody" element={<Fullbodywax />} />
        <Route path="category/waxing/underarm" element={<Underarmwax />} />
        <Route path="category/threadingservices" element={<Threadingservices />} />

        <Route path="category/cleanupservices" element={<CleanupServices />} />

        <Route path="category/detanbleach" element={<Detanbleach />} />
        <Route path="category/detanbleach/combo" element={<Combodetanbleach />} />
        <Route path="category/detanbleach/bleach" element={<Bleach />} />
        <Route path="category/detanbleach/detan" element={<Detan />} />

        <Route path="category/manipediservices" element={<Manipediservices />} /> {/* New route for manipediservices page */} 
        
        <Route path="/orrbiitgo" element={<TravelHomePage />} /> {/* New route for travel home page */}
        
        
        
        <Route path="/orrbiitrelief/home" element={<NGOHome />} /> {/* New route for NGO home page 2 */}
         {/* Add more routes for NGO pages as needed */}
        
      </Routes>
      <SpeedInsights/>
    </Router>
  );
}

export default App;
